import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const PackageIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19.556 7.688L12 12M12 12L4.444 7.688M12 12V20.675M15 9.5L8 5.5M20 15.706V8.294C20 7.981 20 7.825 19.955 7.685C19.915 7.562 19.85 7.448 19.765 7.353C19.668 7.245 19.535 7.169 19.268 7.017L12.691 3.263C12.439 3.119 12.313 3.047 12.179 3.019C12.061 2.994 11.939 2.994 11.821 3.019C11.687 3.047 11.561 3.119 11.309 3.263L4.732 7.017C4.465 7.169 4.332 7.245 4.235 7.353C4.149 7.448 4.085 7.562 4.045 7.685C4 7.825 4 7.981 4 8.294V15.706C4 16.019 4 16.175 4.045 16.315C4.085 16.438 4.149 16.552 4.235 16.647C4.332 16.755 4.465 16.831 4.732 16.983L11.309 20.737C11.561 20.881 11.687 20.953 11.821 20.981C11.939 21.006 12.061 21.006 12.179 20.981C12.313 20.953 12.439 20.881 12.691 20.737L19.268 16.983C19.535 16.831 19.668 16.755 19.765 16.647C19.85 16.552 19.915 16.438 19.955 16.315C20 16.175 20 16.019 20 15.706Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);

PackageIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(PackageIcon);
